import { render, staticRenderFns } from "./Boleado.vue?vue&type=template&id=ee0266f2&scoped=true&"
import script from "./Boleado.vue?vue&type=script&lang=js&"
export * from "./Boleado.vue?vue&type=script&lang=js&"
import style0 from "./Boleado.vue?vue&type=style&index=0&id=ee0266f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0266f2",
  null
  
)

export default component.exports